import React, {useEffect} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Helmet, HelmetProvider} from "react-helmet-async";
import styled from "styled-components";
import {Img} from "../../components/Img";
import {useDispatch, useSelector} from "react-redux";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {fetchHome} from "../../api/redux/home";
import {ApiParam} from "../../api/network/apiParams";
import ReactHtmlParser from "react-html-parser";

const Home = () => {
    const dispatch = useDispatch();

    // api call
    useEffect(() => {
        let api_url = apiEndPoints.SECTIONS;

        let api_params = {
            [ApiParam.TYPE]: "slug",
            [ApiParam.VALUE]: "home",
            [ApiParam.GET_SECTION]: "yes",
            [ApiParam.IMAGE]: "yes",
            [ApiParam.POST]: "yes",
        };

        dispatch(fetchHome([api_url, api_params]));
    }, []);

    const getData = useSelector((state) => state.home);
    const data = getData?.posts?.data;
    const about = getData?.posts?.data?.sections?.find(
        (f) => f?.section_data?.slug === "about"
    )?.section_data;

    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | About</title>
                <meta name="Architech Shamsul Wares"
                      content="Our current mode and depiction of existence become almost
incomprehensible due to the explosion of unimaginable visual culture that
clearly asks (in a certain way) the question of how all these media
representations inform our perception of ourselves and our understanding
of the world around us."/>
            </Helmet>
            <StyledSection>
                <Container>
                    <Row className={'person-wrap'}>
                        <Col lg={6} sm={12}>
                            <div className="person">
                                <Img src={data?.page_images?.list?.[0]?.full_path}/>
                            </div>
                        </Col>
                        <Col lg={6} sm={12}>
                            <div className="person-details">
                                <p>{ReactHtmlParser(about?.description)}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledSection>
        </HelmetProvider>
    );
};

const StyledSection = styled.section`
    .person {
        position: relative;
        padding-top: calc(500 / 470 * 100%);
    }

    .person-details p {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        text-align: justify;
        padding-right: 30px;
        overflow-y: scroll;
        height: 500px;

        /* For WebKit browsers */
        scrollbar-width: thin; /* Makes scrollbar thinner for Firefox */
        scrollbar-color: rgba(112, 112, 112, 0.5) transparent; /* Custom color for Firefox */

        &::-webkit-scrollbar {
            width: 1px; /* Set the scrollbar width */
            background: transparent; /* Optional: Background of the scrollbar */
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(112, 112, 112, 0.5); /* Color of the scrollbar thumb */
            border-radius: 5px; /* Rounded corners */
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(112, 112, 112, 0.5); /* Color when hovering over the scrollbar thumb */
        }

        &::-webkit-scrollbar-track {
            background: transparent; /* Optional: Track background color */
        }
    }

    /* Normal desktop :1200px. */
    @media (min-width: 1920px) {
        .container {
            margin: 0;
        }
    }

    /* Normal desktop :992px. */
    @media (min-width: 992px) and (max-width: 1200px) {
        .container {
            margin: 0;
        }
    }

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        .person-details p {
            margin-top: 30px;
            margin-bottom: 30px;
        }
    }

    /* Tablet desktop :991px. */
    @media (max-width: 991px) {
        .person-details {
            margin-top: 30px;
        }
    }

    /* Small mobile :320px. */
    @media (max-width: 767px) {
        .person-details {
            margin-top: 30px;
            margin-bottom: 30px;
        }
    }
`;


export default Home;
